export const initExperienceState = {
  workPlace: '',
  position: '',
  startDate: '',
  endDate: '',
  viewPermission: 'public',
};

export const initVolunteeringAcvitityState = {
  position: '',
  startDate: '',
  endDate: '',
  viewPermission: 'public',
  description: '',
  link: '',
  organization: '',
};

export const initProjectState = {
  projectName: '',
  position: '',
  startDate: '',
  endDate: '',
  viewPermission: 'public',
  mission: '',
  description: '',
  numberOfMembers: '',
  link: '',
};

export const initContactState = {
  contactType: '',
  contactInfo: '',
  viewPermission: 'public',
};

export const initRewardState = {
  rewardName: '',
  organization: '',
  grantDate: '',
  link: '',
  description: '',
  viewPermission: 'public',
};

export const initCertificateState = {
  certificateName: '',
  organization: '',
  grantDate: '',
  link: '',
  description: '',
  viewPermission: 'public',
};

export const initSchoolState = {
  schoolName: '',
  major: '',
  startDate: '',
  endDate: '',
  viewPermission: 'public',
};

export const initSocialLinkState = {
  link: '',
  socialNetwork: '',
  viewPermission: 'public',
};

export const initIntroductionState = {
  bio: '',
};

export const initWebsiteState = {
  link: '',
  viewPermission: 'public',
};
